/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const CollectiblesIcon: React.SFC = () => {
    return (
        <svg width="46" height="46" viewBox="0 0 46 46" xmlns="http://www.w3.org/2000/svg">
            <title>Icon / collectibles</title>
            <defs>
                <path id="a01" d="M0 38h27V0H0z" />
            </defs>
            <g fill="none" fillRule="evenodd">
                <path stroke="#FCA61B" d="M15.5 29.5h16v-15h-16zM18.5 14.5h10v-7h-10z" />
                <g transform="translate(10 4)">
                    <path d="M26.5 26.5h-3v-15h.692c1.275 0 2.308 1.033 2.308 2.308V26.5zM3.5 26.5h-3V13.808c0-1.275 1.033-2.308 2.308-2.308H3.5v15z" stroke="#FCA61B" />
                    <mask id="b01" fill="#fff">
                        <use xlinkHref="#a01" />
                    </mask>
                    <path stroke="#FCA61B" mask="url(#b01)" d="M6.5 36.5h4v-11h-4zM16.5 36.5h4v-11h-4z" />
                    <path fill="#FFF" mask="url(#b01)" d="M6.5 8.5h2v-3h-2" />
                    <path stroke="#FCA61B" mask="url(#b01)" d="M6.5 8.5h2v-3h-2z" />
                    <path fill="#FFF" mask="url(#b01)" d="M18.5 8.5h2v-3h-2" />
                    <path stroke="#FCA61B" mask="url(#b01)" d="M18.5 8.5h2v-3h-2z" />
                    <path fill="#FFF" mask="url(#b01)" d="M10.5 3.5h6v-2h-6" />
                    <path stroke="#FCA61B" mask="url(#b01)" d="M10.5 3.5h6v-2h-6z" />
                    <path fill="#FFF" mask="url(#b01)" d="M8.5 20.5h10v-3h-10" />
                    <path stroke="#FCA61B" mask="url(#b01)" d="M8.5 20.5h10v-3h-10zM12.5 6.5c0 .553-.448 1-1 1s-1-.447-1-1c0-.553.448-1 1-1s1 .447 1 1zM16.5 6.5c0 .553-.448 1-1 1s-1-.447-1-1c0-.553.448-1 1-1s1 .447 1 1z" />
                    <path fill="#FFF" mask="url(#b01)" d="M15.5 37.5h6v-3h-6" />
                    <path stroke="#FCA61B" mask="url(#b01)" d="M15.5 37.5h6v-3h-6z" />
                    <path fill="#FFF" mask="url(#b01)" d="M5.5 37.5h6v-3h-6" />
                    <path stroke="#FCA61B" mask="url(#b01)" d="M5.5 37.5h6v-3h-6z" />
                    <path fill="#FCA61B" mask="url(#b01)" d="M9 16h1v-2H9M11 16h1v-2h-1M13 16h1v-2h-1M15 16h1v-2h-1M17 16h1v-2h-1M15 2h1V0h-1M11 2h1V0h-1" />
                    <path stroke="#FCA61B" mask="url(#b01)" d="M3.5 16.5h2v-4h-2zM21.5 16.5h2v-4h-2z" />
                </g>
            </g>
        </svg>
    )
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/AssetsIcons/Collectibles.tsx